/* unplugin-vue-components disabled */import { render } from "./Booking.vue?vue&type=template&id=2aa8d760&ts=true"
import script from "./Booking.vue?vue&type=script&lang=ts"
export * from "./Booking.vue?vue&type=script&lang=ts"

import "./Booking.vue?vue&type=style&index=0&id=2aa8d760&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__